<script lang="ts">
    import type { Result } from '@shared/types/utilities';
    import type { TileListInitialSession } from '@tilelist/application/core/TileListInitialSession.ts';
    import TileListPageError from '@tilelist/components/tile-list-error/TileListPageError.svelte';
    import FallbackTileListPageController from '@tilelist/components/tilelist-fallback/FallbackTileListPage.svelte';

    type Props = {
        result: Result<TileListInitialSession>;
    };

    const { result }: Props = $props();

    const isFallbackError = $derived(
        result.state === 'error' ||
            (result.state === 'success' &&
                result.payload.page.isFallback &&
                result.payload.page.tileListItems.length === 0),
    );
</script>

{#if isFallbackError}
    <TileListPageError />
{:else if result.state === 'success'}
    <FallbackTileListPageController initialSession={result.payload} />
{/if}
